module.exports = __webpack_public_path__ + "static/img/brees-2017-slide-6.6a29291.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2017-slide-6.jpg
// module id = 5r6R
// module chunks = 1